'use client';

import { Logo } from '@/components/LogoV2';
import { useTokenSearch } from '@/hooks/useTokenSearch';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function Landing() {
  const router = useRouter();
  const { handleSearch } = useTokenSearch(router);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      handleSearch(searchQuery.trim(), 'landing');
    }
  };

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Search CA Hero Section */}
      <div className="w-full bg-gradient-to-b from-gray-900 to-black pt-12 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto flex flex-col items-center">
            <Logo width={120} height={120} className="drop-shadow-lg" />

            <h1 className="text-6xl md:text-5xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600 leading-normal py-2">
              Rugs shall not pass
            </h1>

            <form onSubmit={handleSearchSubmit} className="w-full max-w-2xl mb-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search for a Solana token address..."
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  className="w-full bg-gray-900 border border-gray-700 rounded-lg py-4 px-6 pr-12 text-lg text-white placeholder-gray-500 focus:outline-none focus:border-purple-500 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-purple-500 hover:text-purple-400 transition-colors"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>
            </form>

            <p className="text-sm text-gray-500 text-center mb-8">
              The #1 Anti Rug Platform on Solana. Hosting the most powerful model and anti rug
              tools.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-7xl mx-auto space-y-48">
          {/* Ape in with confidence section */}
          <section>
            <h2 className="text-5xl font-bold mb-10">Ape in with confidence</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Web app card - Top Left */}
              <div className="bg-gradient-to-br from-gray-900 to-blue-900 p-8 rounded-xl">
                <div className="flex items-center mb-4">
                  <span className="bg-blue-800 text-blue-300 p-1 rounded inline-flex items-center mr-2">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4z" />
                      <path d="M3 10a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z" />
                      <path d="M3 16a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z" />
                    </svg>
                  </span>
                  <span className="text-blue-300 font-medium">Web app</span>
                </div>

                <h3 className="text-2xl text-blue-300 font-medium mb-6">
                  Rug detection made simple. Check tokens on Solana.
                </h3>

                <div className="space-y-2">
                  {/* Token header */}
                  <div className="flex justify-between px-3 mb-1 text-white">
                    <span>Token</span>
                    <div className="flex justify-between gap-16">
                      <span>Market Cap</span>
                      <span>AI SAFETY SCORE</span>
                    </div>
                  </div>

                  {/* Token rows */}
                  <a
                    href="https://www.antirug.ai/ca/9BB6NFEcjBCtnNLFko2FqVQBq8HHM13kCyYcdQbgpump"
                    className="flex items-center justify-between bg-black/30 p-3 rounded-lg hover:bg-black/50 transition"
                  >
                    <div className="flex items-center">
                      <img
                        src="coin/fart.png"
                        alt="Fartcoin"
                        className="w-6 h-6 rounded-full mr-3 object-cover"
                      />
                      <div>
                        <span className="font-medium">Fartcoin</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-16">
                      <span>$1.2B</span>
                      <span className="text-green-400">▲ 93.86%</span>
                    </div>
                  </a>

                  <a
                    href="https://www.antirug.ai/ca/6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN"
                    className="flex items-center justify-between bg-black/30 p-3 rounded-lg hover:bg-black/50 transition"
                  >
                    <div className="flex items-center">
                      <img
                        src="coin/trump.png"
                        alt="TRUMP"
                        className="w-6 h-6 rounded-full mr-3 object-cover"
                      />
                      <div>
                        <span className="font-medium">TRUMP</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-16">
                      <span>$2.5B</span>
                      <span className="text-orange-400">■ 56.22%</span>
                    </div>
                  </a>

                  <a
                    href="https://www.antirug.ai/ca/EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm"
                    className="flex items-center justify-between bg-black/30 p-3 rounded-lg hover:bg-black/50 transition"
                  >
                    <div className="flex items-center">
                      <img
                        src="coin/wif.png"
                        alt="WIF"
                        className="w-6 h-6 rounded-full mr-3 object-cover"
                      />
                      <div>
                        <span className="font-medium">dogwifhat</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-16">
                      <span>$1.1B</span>
                      <span className="text-green-400">▲ 82.97%</span>
                    </div>
                  </a>

                  <a
                    href="https://www.antirug.ai/ca/Df6yfrKC8kZE3KNkrHERKzAetSxbrWeniQfyJY4Jpump"
                    className="flex items-center justify-between bg-black/30 p-3 rounded-lg hover:bg-black/50 transition"
                  >
                    <div className="flex items-center">
                      <img
                        src="coin/chillguy.png"
                        alt="CHILLGUY"
                        className="w-6 h-6 rounded-full mr-3 object-cover"
                      />
                      <div>
                        <span className="font-medium">CHILLGUY</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-16">
                      <span>$105M</span>
                      <span className="text-green-400">▲ 84.68%</span>
                    </div>
                  </a>

                  <a
                    href="https://www.antirug.ai/ca/JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN"
                    className="flex items-center justify-between bg-black/30 p-3 rounded-lg hover:bg-black/50 transition"
                  >
                    <div className="flex items-center">
                      <img
                        src="coin/jup.png"
                        alt="JUP"
                        className="w-6 h-6 rounded-full mr-3 object-cover"
                      />
                      <div>
                        <span className="font-medium">JUP</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-16">
                      <span>$1.4B</span>
                      <span className="text-green-400">▲ 81.25%</span>
                    </div>
                  </a>
                </div>
              </div>

              {/* AntiRug partner card - Top Right */}
              <div className="bg-gradient-to-br from-gray-900 to-purple-900 p-8 rounded-xl">
                <div className="flex items-center mb-4">
                  <span className="bg-pink-800 text-pink-300 p-1 rounded inline-flex items-center mr-2">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                  </span>
                  <span className="text-pink-300 font-medium">AntiRug platform</span>
                </div>

                <h3 className="text-2xl text-pink-300 font-medium mb-6">
                  The platform that partners with the best AntiRug tools.
                </h3>

                <div className="bg-black/80 rounded-xl p-6 flex items-center justify-center">
                  <div className="relative h-64 w-64">
                    {/* Orbit path visualization */}
                    <div className="absolute top-0 left-0 w-full h-full rounded-full border border-gray-700 border-dashed"></div>

                    {/* AntiRug logo in the center */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-purple-800 rounded-full flex items-center justify-center z-10">
                      <a href="https://antirug.ai">
                        <img
                          src="/logo.svg"
                          alt="AntiRug"
                          className="w-16 h-16 object-contain hover:scale-110 transition-all duration-300"
                        />
                      </a>
                    </div>

                    {/* Single rotating container for all partner logos */}
                    <div className="absolute top-0 left-0 w-full h-full animate-[spin_20s_linear_infinite]">
                      {/* Partner 1 - Top (0 degrees) */}
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/helio.png"
                              alt="Helio"
                              className="w-10 h-10 object-contain animate-[spin_8s_linear_infinite]"
                            />
                          </div>
                        </a>
                      </div>

                      {/* Partner 2 - Top Right (60 degrees) */}
                      <div className="absolute top-[25%] right-[7%] transform translate-x-1/2 -translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/repo.png"
                              alt="Repo"
                              className="w-10 h-10 object-contain animate-[spin_10s_linear_infinite_reverse]"
                            />
                          </div>
                        </a>
                      </div>

                      {/* Partner 3 - Bottom Right (120 degrees) */}
                      <div className="absolute bottom-[25%] right-[7%] transform translate-x-1/2 translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/solcypher.png"
                              alt="Solcypher"
                              className="w-10 h-10 object-contain animate-[spin_7s_linear_infinite]"
                            />
                          </div>
                        </a>
                      </div>

                      {/* Partner 4 - Bottom (180 degrees) */}
                      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/tank.png"
                              alt="Tank"
                              className="w-10 h-10 object-contain animate-[spin_12s_linear_infinite_reverse]"
                            />
                          </div>
                        </a>
                      </div>

                      {/* Partner 5 - Bottom Left (240 degrees) */}
                      <div className="absolute bottom-[25%] left-[7%] transform -translate-x-1/2 translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/tg.png"
                              alt="TG"
                              className="w-10 h-10 object-contain animate-[spin_9s_linear_infinite]"
                            />
                          </div>
                        </a>
                      </div>

                      {/* Partner 6 - Top Left (300 degrees) */}
                      <div className="absolute top-[25%] left-[7%] transform -translate-x-1/2 -translate-y-1/2">
                        <a
                          href="https://antirug.gitbook.io/antirug/partners"
                          className="block w-14 h-14"
                        >
                          <div className="w-full h-full bg-gray-900 rounded-full flex items-center justify-center shadow-lg border-2 border-gray-800 hover:border-purple-500 transition-colors">
                            <img
                              src="/partner/trenchradar.png"
                              alt="Trench Radar"
                              className="w-10 h-10 object-contain animate-[spin_11s_linear_infinite_reverse]"
                            />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Developer docs card - Bottom Left */}
              <div className="bg-gradient-to-br from-gray-900 to-green-900 p-8 rounded-xl">
                <div className="flex items-center mb-4">
                  <span className="bg-green-800 text-green-300 p-1 rounded inline-flex items-center mr-2">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                      />
                    </svg>
                  </span>
                  <span className="text-green-300 font-medium">Developer docs</span>
                </div>

                <h3 className="text-2xl text-green-300 font-medium mb-6">
                  Build the next generation of safe applications and tools.
                </h3>

                <div className="relative mt-8">
                  <div className="bg-green-900/30 rounded-lg p-3 mb-2">
                    <div className="flex items-center justify-between">
                      <div className="h-3 w-16 bg-green-800 rounded"></div>
                      <div className="h-3 w-8 bg-green-800 rounded"></div>
                    </div>
                  </div>
                  <div className="bg-green-900/30 rounded-lg p-3 mb-2">
                    <div className="h-3 w-24 bg-green-800 rounded"></div>
                  </div>
                  <a
                    href="https://antirug.gitbook.io/antirug"
                    className="bg-green-800 rounded-lg p-3 absolute right-0 border border-green-500 hover:bg-green-700 transition"
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-xs text-green-300 mr-2">GETTING STARTED</div>
                      <svg
                        className="h-4 w-4 text-green-300"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              {/* Security card - Bottom Right */}
              <div className="bg-gradient-to-br from-gray-900 to-purple-900 p-8 rounded-xl">
                <div className="flex items-center mb-4">
                  <span className="bg-purple-800 text-purple-300 p-1 rounded inline-flex items-center mr-2">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                      />
                    </svg>
                  </span>
                  <span className="text-purple-300 font-medium">Security</span>
                </div>

                <h3 className="text-2xl text-purple-300 font-medium mb-6">
                  Protect your bags with rug detection and monitoring.
                </h3>

                <div className="relative mt-8 h-32">
                  <div className="absolute right-0 bottom-0">
                    <div className="relative">
                      <div className="bg-purple-600 h-12 w-12 rounded-full flex items-center justify-center absolute bottom-0 right-10 animate-pulse">
                        <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="bg-purple-700 h-12 w-12 rounded-full flex items-center justify-center absolute bottom-10 right-0 animate-pulse">
                        <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="bg-pink-600 h-12 w-12 rounded-full flex items-center justify-center absolute bottom-20 right-10 animate-pulse">
                        <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                          <path
                            fillRule="evenodd"
                            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="bg-purple-500 h-12 w-12 rounded-full flex items-center justify-center absolute bottom-10 right-20 animate-pulse">
                        <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                          <path
                            fillRule="evenodd"
                            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Trusted by millions section */}
          <section className="pt-16">
            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="md:w-1/3">
                <h2 className="text-5xl font-bold mb-6">Trusted by 100k+ users</h2>
                <p className="text-gray-300 mb-8">
                  AntiRug products are powered by the AntiRug Protocol. The protocol is the number
                  one anti-rug platform on Solana that hosts the best rug detection tools.
                </p>
                <a
                  href="https://antirug.gitbook.io/antirug"
                  className="flex items-center gap-2 bg-transparent border border-gray-700 hover:border-gray-500 rounded-lg px-5 py-2 transition"
                >
                  Learn more
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 ml-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>

              <div className="md:w-2/3 grid grid-cols-2 gap-4">
                <div className="bg-gray-900 p-8 rounded-xl">
                  <p className="text-gray-400 mb-4">All time scans</p>
                  <p className="text-4xl font-bold">3.3M</p>
                </div>

                <div className="bg-gray-900 p-8 rounded-xl">
                  <p className="text-green-500 mb-4">Active users</p>
                  <p className="text-4xl font-bold text-green-500">20k</p>
                </div>

                <div className="bg-gray-900 p-8 rounded-xl">
                  <p className="text-gray-400 mb-4">Ruggers detected</p>
                  <p className="text-4xl font-bold">200k</p>
                </div>

                <div className="bg-gray-900 p-8 rounded-xl">
                  <p className="text-gray-400 mb-4">Community members</p>
                  <p className="text-4xl font-bold">30k</p>
                </div>
              </div>
            </div>
          </section>

          {/* Connect with us section */}
          <section className="pt-16">
            <h2 className="text-5xl font-bold mb-12">Connect with us</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl">
              {/* Blog card */}
              <a
                href="https://www.antirug.ai/blog"
                className="bg-[#1c1c1a] p-8 rounded-xl h-64 flex flex-col hover:bg-[#262624] transition-colors"
              >
                <div className="flex items-center mb-6">
                  <svg
                    className="h-5 w-5 text-gray-400 mr-2"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  </svg>
                  <span className="text-gray-400 font-medium">Blog</span>
                </div>

                <p className="text-gray-400 mt-4">Insights about anti-rugging</p>

                <div className="mt-auto">
                  <span className="text-gray-400 flex items-center">
                    Visit blog
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </div>
              </a>

              {/* Telegram card */}
              <a
                href="https://t.me/antirugagent"
                className="bg-[#1e3a8a] p-8 rounded-xl h-64 flex flex-col hover:bg-[#1e40af] transition-colors"
              >
                <div className="flex items-center mb-6">
                  <svg
                    className="h-5 w-5 text-blue-400 mr-2"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                  </svg>
                  <span className="text-blue-400 font-medium">Telegram</span>
                </div>

                <p className="text-blue-400 mt-4">Join the ANTIRUG community</p>

                <div className="mt-auto">
                  <span className="text-blue-400 flex items-center">
                    Join channel
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </div>
              </a>

              {/* Stay connected card */}
              <a
                href="https://x.com/Antirug_ai"
                className="bg-[#3b0764] p-8 rounded-xl h-64 flex flex-col hover:bg-[#4c0564] transition-colors"
              >
                <div className="flex items-center mb-6">
                  <svg
                    className="h-5 w-5 text-pink-500 mr-2"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                  <span className="text-pink-500 font-medium">Stay connected</span>
                </div>

                <p className="text-pink-500 mt-4">Follow @AntiRug_ai on X for latest updates</p>

                <div className="mt-auto">
                  <span className="text-pink-500 flex items-center">
                    Follow us
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </div>
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
